import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

// Define table data structure
const tableData = [
  { id1: "1", name1: " ", count1: " पारगाव / पारगावडुंगी", id2: "", name2: "", count2: ""  },
  { id1: "2", name1: " ", count1: "७ हेक्टर ", id2: "", name2: "", count2: "" },
  { id1: 3, name1: "एकूण लोकसंख्या", count1:" ३१०३", id2: 49, name2: "बस स्थानक ", count2: "२" },
  { id1: 4, name1: "गुरचरण क्षेत्रफळ", count1: 0, id2: 50, name2: "सार्वजनिक विहीर ", count2: "४" },
  { id1: 5, name1: "वनक्षेत्रफळ", count1: 0, id2: 51, name2: "खाजगी विहीर ", count2: "१" },
  { id1: 6, name1: "गावठाण क्षेत्रफळ", count1: "५ हेक्टर", id2: 52, name2: "पाथ दिवे ", count2: "७२" },
  { id1: 7, name1: "आदिवासी लोकसंख्या", count1: "२३१", id2: 53, name2: "पंचायत", count2: 0 },
  { id1: 8, name1: "दारिद्र रेषेखालील कुटुंब ", count1: "४७", id2: 54, name2: "शोषखड्डे", count2: "२" },
  { id1: 9, name1: "एकून कुटुंब संख्या ", count1: "७२८", id2: 55, name2: "किरना दुकान संख्या ", count2: "१५"},
  { id1: 10, name1: "एकून घरांची  संख्या", count1: "१३०५", id2: 56, name2: "मटन / चिकन  शोप ", count2: "२" },
  { id1: 11, name1: "वयक्तिक शोचालाय कुटुंब संख्या", count1: "१२८२", id2: 57, name2: "खाजगी बोरेवेल ", count2: "१" },
  { id1: 12, name1: " सार्वजनिक शोचालाय कुटुंब संख्या", count1: "६४", id2: 58, name2: "सैनिक ", count2: "१" },
  { id1: 13, name1: "गटाराला जोडणारी कुटुंब  संख्या", count1: "५२३", id2: 59, name2: "पोलीस ", count2: "१" },
  { id1: 14, name1: "शुभ्र रेशनकार्ड धारक संख्या", count1: "", id2: 60, name2: "इंडिअन नेव्ही", count2: "१" },
  { id1: 15, name1: "केशरी रेशनकार्ड धारक संख्या", count1: "", id2: 61, name2: "वकील ", count2: "२"},
  { id1: 16, name1: "पिवळे रेशनकार्ड धारक संख्या", count1: "", id2: 61, name2: "इंजिनीअर ", count2: "३" },
  { id1: 17, name1: "घरपट्टी ", count1: "१८५४९५२ ", id2: 63, name2: "डॉक्टर्स व दवाखाने ", count2: "२" },
  { id1: 18, name1: "विजकर ", count1: "३७६६० ", id2: 64, name2: "शेतकरी संख्या ", count2: "४" },
  { id1: 19, name1: "आरोग्य कर ", count1: "३७६६०", id2: 65, name2: "लोहार ", count2: "१" },
  { id1: 20, name1: "दुकान कर ", count1: "0", id2: 66, name2: "प्लंबर ", count2: "१"},
  { id1: 21, name1: "गिरणी कर ", count1: "0", id2: 67, name2: "वेल्डर ", count2: "२" },
  { id1: 22, name1: "हॉटेल कर ", count1: "0", id2: 68, name2: "सरकारी कर्मचारी ", count2: "१५" },
  { id1: 23, name1: "दाखला फी", count1: "३0", id2: 69, name2: "माजी  सरकारी कर्मचारी ", count2: "१०" },
  { id1: 24, name1: " नोटीस फी", count1: "0", id2: 70, name2: "महिला बचत गट संख्या ", count2: "२१"},
  { id1: 25, name1: "अंगणवाडी ", count1: "४", id2: 71, name2: "पुरुष बचत गट संख्या", count2: "१" },
  { id1: 26, name1: "प्राथमिक शाळा  ", count1: "१", id2: 72, name2: "पुरुष भजन मंडळ  संख्या", count2: "२" },
  { id1: 27, name1: " मध्यमिक शाळा ", count1: "0", id2: 73, name2: "मेडीकॅल स्टोरे ", count2: "१" },
  { id1: 28, name1: "अंगणवाडी सेविका संख्या ", count1: "४", id2: 74, name2: "नळ पाणी पुरवठा योजना ", count2: "१" },
  { id1: 29, name1: "प्राथमिक शिक्षक संख्या ", count1: "७", id2: 75, name2: "टेम्पो ", count2: "५"},
  { id1: 30, name1: " प्राथमिक आरोग्य केंद्र ", count1: "१", id2: 76, name2: "रिक्षा ", count2: "२५" },
  { id1: 31, name1: "गावातील पुरुष  शिक्षक संख्या ", count1: "३", id2: 77, name2: "अपंग संख्या पुरुष ", count2: "८" },
  { id1: 32, name1: "गावातील महिला  शिक्षक संख्या ", count1: "१", id2: 78, name2: "अपंग संख्या महिला" , count2: "१५" },
  { id1: 33, name1: " शासकीय इमारती ", count1: "३", id2: 79, name2: "विधवा संख्या महिला ", count2: "४५" },
  { id1: 34, name1: " तलाठी कार्यालय", count1: "0", id2: 80, name2: "फोटो स्टुडीओ ", count2: "१" },
  { id1: 35, name1: "पोस्ट ऑफिस ", count1: "१", id2: 81, name2: "इलेक्ट्रिक बाईक ", count2: "१५" },
  { id1: 36, name1: "पशुवैद्यकीय दवाखाना ", count1: "१" },
  { id1: 37, name1: " फोरेस्ट ऑफिस", count1: "0"},
  { id1: 38, name1: " व्यायामशाला", count1: "१"},
  { id1: 39, name1: " वाचनालय", count1: "१" },
  { id1: 40, name1: "क्रीडांगण  ", count1: "१"},
  { id1: 41, name1: " मंदिर ", count1: "५" },
  { id1: 42, name1: " गोशाळा ", count1: "0" },
  { id1: 43, name1: " गणपती घाट", count1: "१" },
  { id1: 44, name1: " स्मशानभूमी ", count1: "२" },
  { id1: 45, name1: " गार्डन ", count1: "0"},
  { id1: 46, name1: " समाज मंदिर ", count1: "२"},
  { id1: 47, name1: " नर्सरी ", count1: "0" },
  { id1: 48, name1: " तलाव ", count1: "0"},

];

const AdarshTakta: React.FC = () => {
  return (
    <TableContainer component={Paper} style={{ maxWidth: "90%", margin: "auto", marginTop: "20px",marginBottom: "50px" }}>
      <Table style={{ borderCollapse: "collapse" }}>
        {/* Table Header */}
        <TableHead>
          <TableRow style={{ backgroundColor: "#00106e", color: "white" }}>
            <TableCell style={{ color: "white", fontWeight: "bold", fontSize: "22px", border: "1px solid white" }}>
              अ.क्र
            </TableCell>
            <TableCell style={{ color: "white", fontWeight: "bold", fontSize: "22px", border: "1px solid white" }}>
              तपशील
            </TableCell>
            <TableCell style={{ color: "white", fontWeight: "bold", fontSize: "22px", border: "1px solid white" }}>
              गावनिहाय माहिती
            </TableCell>
            <TableCell style={{ color: "white", fontWeight: "bold", fontSize: "22px", border: "1px solid white" }}>
              अ.क्र
            </TableCell>
            <TableCell style={{ color: "white", fontWeight: "bold", fontSize: "22px", border: "1px solid white" }}>
              तपशील
            </TableCell>
            <TableCell style={{ color: "white", fontWeight: "bold", fontSize: "22px", border: "1px solid white" }}>
              गावनिहाय माहिती
            </TableCell>
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {tableData.map((row, index) => (
            <TableRow key={index} style={{ backgroundColor: index < 2 ? "#f1f1f1" : "white" }}>
              <TableCell style={{ border: "1px solid gray", fontSize: "18px", fontWeight: index < 2 ? "bold" : "normal" }}>
                {row.id1}
              </TableCell>
              <TableCell style={{ border: "1px solid gray", fontSize: "18px", fontWeight: index < 2 ? "bold" : "normal" }}>
                {row.name1}
              </TableCell>
              <TableCell style={{ border: "1px solid gray", fontSize: "18px", fontWeight: index < 2 ? "bold" : "normal" }}>
                {row.count1}
              </TableCell>
              <TableCell style={{ border: "1px solid gray", fontSize: "18px", fontWeight: index < 2 ? "bold" : "normal" }}>
                {row.id2}
              </TableCell>
              <TableCell style={{ border: "1px solid gray", fontSize: "18px", fontWeight: index < 2 ? "bold" : "normal" }}>
                {row.name2}
              </TableCell>
              <TableCell style={{ border: "1px solid gray", fontSize: "18px", fontWeight: index < 2 ? "bold" : "normal" }}>
                {row.count2}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AdarshTakta;
